import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';
import { DeviceSalesReportResponse } from '../../types/device-report/device-report.type';

export type GetDeviceSalesReportRequest = {
  organizationId?: number;
  subOrgIds?: string;
  orderTypes?: string;
  deviceModelsIds?: string;
  year?: number;
  months?: string;
};

export const getDeviceSalesReportData = createAsyncThunk<
  DeviceSalesReportResponse,
  { data: GetDeviceSalesReportRequest },
  { state: RootReducerState }
>('deviceSalesReport/getDeviceSalesReportData', async ({ data }, thunkAPI) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/inventory/device-sales-report`, {
      params: data,
    });
    return response.data;
  } catch (error) {
    return rejectWithApiError({
      thunkAPI,
      error,
      fallback: 'Error during fetching device sales report!',
    });
  }
});
